import CoffeesComponent from "../Components/CoffeesComponent";

const Coffees = () => {
    return (
        <>
            <CoffeesComponent />
        </>
    )
}

export default Coffees;
